module.exports = __webpack_public_path__ + "img/purple-circle-table-6.6ee247c8.png";